const channelDictPT = {
  channelHeaderNote: "Lojas selecionadas para a ScontiPoste",
  channelCart: "Carrinho",
  channelTicketTitle: "{percent}% de cashback ScontiPoste",
  channelTicketRule:
    "Pague com seu cartão Postepay ou BancoPosta: a Poste Italiane credita o cashback, em geral em até 5 dias.",
  channelTicketWarning:
    "Com outros cartões a compra vale, mas a Poste Italiane não reconhece o cashback.",
  channelSearchPlaceholder: "Busque um produto",
  channelSearch: "Buscar",
  channelAllCategories: "Tudo",
  channelNoProducts: "Nenhum produto aqui por enquanto. Tente outra categoria ou outra busca.",
  channelLoadMore: "Mostrar mais produtos",
  channelFreeDelivery: "Frete grátis",
  channelPickup: "Retirada na loja",
  channelSoldBy: "Vendido por {seller}",
  channelAddToCart: "Adicionar ao carrinho",
  channelAdded: "Adicionado ao carrinho",
  channelGoToCart: "Ir para o carrinho",
  channelQuantity: "Quantidade",
  channelChooseOption: "Escolha {name}",
  channelChooseVariation: "Escolha uma opção",
  channelOutOfStock: "Esgotado",
  channelPickupAt: "Retirada em: {address}",
  channelPickupDays: "Você tem {days} dias para retirar.",
  channelBackToShop: "Voltar aos produtos",
  channelDescription: "Descrição",
  channelCartTitle: "Seu carrinho",
  channelCartEmpty: "Seu carrinho está vazio.",
  channelCartEmptyAction: "Ver produtos",
  channelShippedBy: "Enviado por {seller}",
  channelPickupFrom: "Retirada em {seller}",
  channelRemove: "Remover",
  channelDecrease: "Diminuir quantidade",
  channelIncrease: "Aumentar quantidade",
  channelShipping: "Frete",
  channelShippingFree: "Grátis",
  channelTotal: "Total",
  channelPricesIncludeFees: "Os preços incluem as taxas de serviço.",
  channelCheckoutCta: "Continuar para o pagamento",
  channelUnavailableItem: "Este produto não está mais disponível: remova-o para continuar.",
  channelCheckoutTitle: "Finalize sua compra",
  channelYourDetails: "Seus dados",
  channelFirstname: "Nome",
  channelSurname: "Sobrenome",
  channelEmail: "E-mail",
  channelEmailHelp: "Enviamos a confirmação do pedido para este e-mail.",
  channelPhone: "Telefone (opcional)",
  channelDeliveryAddress: "Endereço de entrega",
  channelAddress: "Rua",
  channelNumber: "Número",
  channelPostalCode: "CEP (CAP)",
  channelCity: "Cidade",
  channelProvince: "Província (sigla, ex.: RM)",
  channelItalyOnly: "Entregamos só na Itália.",
  channelPickupOnly: "Todos os produtos são retirados na loja: não precisa de endereço.",
  channelPayment: "Pagamento",
  channelCardHelp: "Use seu cartão Postepay ou BancoPosta para receber o cashback.",
  channelCardName: "Nome no cartão",
  channelCardNumber: "Número do cartão",
  channelCardExpiry: "Validade",
  channelCardCvv: "CVV",
  channelPay: "Pagar {total}",
  channelFillRequired: "Preencha os campos obrigatórios.",
  channelInvalidEmail: "Informe um e-mail válido.",
  channelInvalidCard: "Confira os dados do cartão.",
  channelPaymentFailed: "O pagamento não foi aprovado. Tente de novo ou use outro cartão.",
  channelAccountNote: "Com a compra criamos uma conta Extraconomy gratuita para você acompanhar seus pedidos.",
  channelOrderSummary: "Resumo",
  channelThanksTitle: "Pedido confirmado",
  channelThanksIntro: "Obrigado! Recebemos o pagamento de {total}.",
  channelThanksOrders: "Seus pedidos",
  channelOrderNumber: "Pedido nº {id}",
  channelThanksDelivery: "O vendedor envia o pacote para o endereço que você informou.",
  channelThanksPickup: "Você retira o produto na loja do vendedor.",
  channelThanksNewAccount:
    "Criamos sua conta Extraconomy com {email}. Abra o e-mail que enviamos e escolha uma senha para acompanhar seus pedidos.",
  channelThanksExistingAccount: "O pedido está na sua conta Extraconomy ({email}). Entre para acompanhá-lo.",
  channelLogin: "Entrar",
  channelThanksCashback:
    "Se você pagou com Postepay ou BancoPosta, a Poste Italiane credita {percent}% de cashback, em geral em até 5 dias.",
  channelContinueShopping: "Continuar comprando",
  channelThanksMissing: "Os detalhes do pedido não estão mais nesta página. Você os encontra no e-mail de confirmação.",
  channelPasswordTitle: "Crie sua senha",
  channelPasswordIntro: "Com a senha você entra na sua conta e acompanha seus pedidos.",
  channelPassword: "Senha",
  channelPasswordConfirm: "Repita a senha",
  channelPasswordHelp: "Pelo menos 8 caracteres.",
  channelPasswordMismatch: "As senhas não são iguais.",
  channelPasswordSave: "Criar senha e entrar",
  channelPasswordInvalidLink:
    "O link é inválido ou expirou. Para receber outro, use \"Esqueci a senha\" na página de login.",
  channelGoToLogin: "Ir para o login",
  channelProcessingTitle: "Estamos confirmando o pagamento",
  channelProcessingText: "Pode levar alguns segundos. Não feche nem recarregue esta página.",
  channelInvalidItalianAddress: "Informe um CAP italiano de 5 dígitos e a sigla da província (ex.: RM).",
  channelError500438: "Informe um CAP italiano de 5 dígitos e a sigla da província (ex.: RM).",
  orderDetailsChannelCashbackBuyer: "Pedido ScontiPoste: o cashback não é creditado na Extraconomy. Se você pagou com cartão Postepay ou BancoPosta, a Poste Italiane credita no cartão, em geral em até 5 dias.",
  orderDetailsChannelCashbackSeller: "Pedido ScontiPoste: este cashback é descontado da venda e pago ao cliente pela Poste Italiane, no cartão dele.",
  channelLoading: "Carregando",
  channelGenericError: "Algo deu errado. Tente de novo em instantes.",
  channelError500037: "Produto não encontrado.",
  channelError500069: "Escolha uma opção do produto.",
  channelError500074: "Um dos produtos esgotou. Confira o carrinho.",
  channelError500417: "Esta loja não existe.",
  channelError500418: "Esta loja não está disponível no momento.",
  channelError500419: "Um dos produtos não está mais disponível. Confira o carrinho.",
  channelError500420: "Confira as quantidades no carrinho.",
  channelError500423: "Os preços do carrinho mudaram. Confira o total e tente de novo.",
  channelError500424: "A sessão de pagamento não é válida. Recarregue a página e tente de novo.",
  channelError500425: "Não conseguimos confirmar o pagamento. Se houve cobrança, o valor é estornado.",
  channelError500426: "Informe o endereço de entrega.",
  channelError500427: "Entregamos só na Itália.",
  channelError500428: "Informe nome, sobrenome e um e-mail válido.",
  channelError500429: "Você não pode comprar os seus próprios produtos.",
  channelError500430: "Não conseguimos concluir a compra e o pagamento foi estornado.",
  channelError500431: "O link é inválido ou expirou. Para receber outro, use \"Esqueci a senha\" na página de login.",
  channelError500432: "A senha precisa ter pelo menos 8 caracteres.",
  channelError500433: "O carrinho tem produtos demais.",
};

export default channelDictPT;
